import { Component, Input, OnInit } from '@angular/core';
import { Vencimiento } from "../../../interfaces/vencimiento";

@Component({
  selector: 'app-card-vencimiento',
  templateUrl: './card-vencimiento.component.html',
  styleUrls: ['./card-vencimiento.component.scss']
})
export class CardVencimientoComponent implements OnInit {

  @Input() vencimiento: Vencimiento;

  ngOnInit(): void {
  }

}